export const GET_INVOICE = "GET_INVOICE"
export const GET_INVOICE_SUCCESS = "GET_INVOICE_SUCCESS"
export const GET_INVOICE_FAIL = "GET_INVOICE_FAIL"

export const MAKE_PAYMENT = "MAKE_PAYMENT"
export const MAKE_PAYMENT_SUCCESS = "MAKE_PAYMENT_SUCCESS"
export const MAKE_PAYMENT_FAIL = "MAKE_PAYMENT_FAIL"

export const TOGGLE_PAYMENT_MODEL = "TOGGLE_PAYMENT_MODEL"